import { Switch } from 'react-router-dom'
import { CIMSPage, Permission } from '@cims-online/shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import IFITracker from './IFITracker'
import IFINotifications from './IFINotifcations'

const IdentifiedFieldIssues: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[CIMSPage.IFITracker.recordPath, CIMSPage.IFITracker.projectPath]}
        permissions={Permission.ViewIdentifiedFieldIssue}
      >
        <IFITracker />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.IFINotifications.projectPath}
        permissions={Permission.ViewIFINotification}
      >
        <IFINotifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default IdentifiedFieldIssues
